var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.getPrice()))]),(_vm.needPriceCorrection())?_c('span',{staticClass:"ml-2 text-warning"},[_c('font-awesome-icon',{attrs:{"icon":"balance-scale"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }